// Added by Sejune Oh on 2020-04-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    TableBody as MaterialUITableBody,
    TableBodyProps as MaterialUITableBodyProps
} from '@material-ui/core'

interface TableBodyBaseProps { }
export type TableBodyProps = Partial<MaterialUITableBodyProps> & TableBodyBaseProps

export const TableBody: FC<TableBodyProps> = ({ ...props }) => {
    return <MaterialUITableBody {...props}></MaterialUITableBody>
}
